<table *ngIf="visibleArtifacts.length > 0" class="content__files-table">
  <thead>
    <tr>
      <th>{{'BASEKNOWLEDGECATALOG.FILE_NAME' | translate}}</th>
      <th>{{'BASEKNOWLEDGECATALOG.FILE_DISPLAYNAME' | translate}}</th>
      <th>{{'BASEKNOWLEDGECATALOG.FILE_DESCRIPTION' | translate}}</th>
      <!--<th>{{'BASEKNOWLEDGECATALOG.FILE_STATUS' | translate}}</th>-->
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let file of visibleArtifacts; let i = index; trackBy: trackByIndex">
      <td>
        <bzg-input class="file-name-input" [maxlength]="'50'" [(ngModel)]="file.FileName" [readonly]="true"
            actionIcnPosition="left" icon="icn-file">
            <bzg-icon [nameIcon]="'icon-file-color'"></bzg-icon>
            <bzg-maxlength-error>{{'KNOWDLEGE_BASE.NAME' | translate}}</bzg-maxlength-error>
        </bzg-input>
      </td>
      <td>
        <bzg-input [id]="'name-input-' + i" [maxlength]="'50'" [(ngModel)]="file.DisplayName"
              [pattern]="'.*'" (ngModelChange)="onArtifactFieldChange(file)">
              <bzg-maxlength-error>{{'BASEKNOWLEDGECATALOG.FILE_NAME' | translate}}</bzg-maxlength-error>
              <bzg-required-error>{{'BASEKNOWLEDGECATALOG.REQUIRED' | translate}}</bzg-required-error>
              <bzg-pattern-error>{{'BASEKNOWLEDGECATALOG.ERROR_PATTERN' | translate}}</bzg-pattern-error>
          </bzg-input>
      </td>
      <td class="col-description">
        <bzg-input [maxlength]="'200'" [(ngModel)]="file.Description"
              [placeholder]="'BASEKNOWLEDGECATALOG.PLACEHOLDER_DESCRIPTION' | translate "
              [pattern]="'.*'" (ngModelChange)="onArtifactFieldChange(file)">
              <bzg-pattern-error>{{'BASEKNOWLEDGECATALOG.ERROR_PATTERN' |
                  translate}}</bzg-pattern-error>
        </bzg-input>
      </td>
      <!--<td>
        <bzg-icon [fill]="color(file.ArtifactStatus)" [nameIcon]="'circle'" [size]="8"></bzg-icon>
        <span class="file-status">{{ statusTranslate(file.ArtifactStatus) }}</span>
      </td>-->
      <td>
          <div class="icon-container" (click)="onRemoveFile(i)">
              <img src="assets/icons/16x_delete.svg" class="icon-auth">
          </div>
      </td>
    </tr>
  </tbody>
</table>

<div class="content__no-records" *ngIf="visibleArtifacts.length === 0">
  <img src="assets/img/files-not-found.png">
  <span class="content__no-records-files">{{ 'BASEKNOWLEDGECATALOG.NO_FILES_MESSAGE' | translate}}</span>
  <span class="content__no-records-uploading">{{ 'BASEKNOWLEDGECATALOG.UPLOADING_MESSAGE' | translate}}</span>
</div>
